import React from "react";
import PropTypes from "prop-types";
import { Image } from "semantic-ui-react";
//import history from '../../utils/history';
import { withRouter, useHistory } from "react-router-dom";
import UserProfileWidget from "../Configuration/UserProfileWidget";
import { usuarioLogueado } from "../../utils/loggedInfo";
import Notificaciones from "../common/Notificaciones";

const HeaderMenu = ({ items = [], location, authInfo }) => {
  let history = useHistory();
  const { rol } = usuarioLogueado();
  const renderOpcionMenu = (label, svg, subMenus, isOptionSelected) => {
    let optionRender = null;

    if (svg !== null) {
      optionRender = (
        <>
          <img src={svg} className="iconosMenu" alt="Imagen"></img> 
          {subMenus && (
            <>
              <i className={"fas fa-angle-down"} key={label + label}>
                {" "}
              </i>
              <ul
                key={label + "" + label}
                className={`sub_menu ${
                  subMenus.length === 1
                    ? "sub_menu_one_option"
                    : "sub_menu_multi_option"
                }`}
              >
                {subMenus.map((sm, k) => {
                  if (sm.roles && !sm.roles.find((x) => x === rol)) return null;
                  return (
                    <li
                      onClick={() =>
                        history.push(sm.route, {
                          opcMenu: label,
                          subMenu: sm.label,
                        })
                      }
                      key={sm.label + "" + k}
                    >
                      <label
                        style={{
                          margin: 0,
                          cursor: "pointer",
                          fontSize: "1.3vw",
                        }}
                      >
                        {sm.label}
                      </label>
                    </li>
                  );
                })}
              </ul>
            </>
          )}
        </>
      );
    }

    return optionRender;
  };

  return (
    <div id="menu" className="menu">
      <Image src="/DasaLogo3.svg" className="logo-menu"></Image>
      <ul>
        {items.map(({ label, svg, subMenus, route, nombre, roles }, key) => {
          const isOptionSelected =
            subMenus && subMenus.some((z) => z.route === location.pathname);
          if (roles && roles.some((x) => x === rol))
            return (
              <>
                <li
                  className={""}
                  key={key}
                  onClick={() => {
                    localStorage.removeItem("classByForm");
                    if (route) history.push(route);
                  }}
                >
                  {renderOpcionMenu(label, svg, subMenus, isOptionSelected)}
                  <span className="nombreMenu">{nombre}</span>
                </li>
              </>
            );
        })}
      </ul>
      <UserProfileWidget authInfo={authInfo} />
      <Notificaciones />
    </div>
  );
};

HeaderMenu.propTypes = {
  items: PropTypes.array.isRequired,
  location: PropTypes.any,
  authInfo: PropTypes.object,
};

export default withRouter(HeaderMenu);
